var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gallery"}},[_c('v-container',[_c('sectionTitle',{attrs:{"title":_vm.title}}),_c('PicGallery')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }